<template>
  <div class="search">
    <div class="search__box">
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="search__box-icon"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.8912 9.47725C12.5612 7.13425 12.3453 3.86025 10.2432 1.75725C7.90025 -0.58575 4.10125 -0.58575 1.75725 1.75725C-0.58575 4.10125 -0.58575 7.89925 1.75725 10.2432C3.86025 12.3453 7.13425 12.5612 9.47725 10.8912L10.4323 11.8462C10.2542 12.5132 10.4262 13.2552 10.9502 13.7782L14.3912 17.2192C15.1722 18.0002 16.4382 18.0002 17.2192 17.2192C18.0002 16.4382 18.0002 15.1722 17.2192 14.3912L13.7782 10.9502C13.2552 10.4262 12.5132 10.2542 11.8462 10.4323L10.8912 9.47725ZM8.82825 3.17225C10.3903 4.73425 10.3913 7.26625 8.82825 8.82825C7.26625 10.3912 4.73425 10.3912 3.17225 8.82825C1.61025 7.26625 1.60925 4.73425 3.17225 3.17225C4.73425 1.60925 7.26625 1.60925 8.82825 3.17225Z"
          fill="var(--menu-text-color)"
        />
      </svg>
    </div>
    <input
      class="search__input"
      :placeholder="$t('controls.searchHolder')"
      type="text"
      v-model="search"
    />
  </div>
</template>

<script>
export default {
    props: ['searchData', 'value'],
    data() {
        return {}
    },
    computed: {
        search: {
            get() {
                return this.value
            },
            set(text) {
                this.$emit('searchData', text)
            },
        },
    },
}
</script>
<style lang="scss" scoped>
.search {
  display: flex;
  align-items: center;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  background: var(--bg-color);
  height: 36px;
  padding: 0 18px;

  // &_reser-inline-p {
  //   .search__input {
  //     padding-bottom: 0;
  //   }
  // }

  &__box {
  }

  &_w209 {
    width: 100%;
    max-width: 209px;
  }

  &__input {
    background-color: transparent;
    border: none;
    outline: none;
    margin-left: 6px;
    color: var(--text-color-grey);
    font-size: 15px;
    font-family: "lexend_deca";
  }
}
</style>
